import lottie from 'lottie-web';

export default class HowWeWork {


	// Constructor
	constructor(asscroll, element) {
		this.asscroll = asscroll;
		this.element = element;

		this.container = this.element.querySelector('.section-how-we-work--scroll');
		this.fixed = this.element.querySelector('.section-how-we-work--fixed');

		this.sectionItems = [...this.container.querySelectorAll('.section-how-we-work--item')]

		this.resize = this.resize.bind(this)
		this.animationLoaded = this.animationLoaded.bind(this);
		this.scroll = this.scroll.bind(this);
		this.scrollMobile = this.scrollMobile.bind(this);

		this.animationIsLoaded = false;
		this.animation = lottie.loadAnimation({
			autoplay: false,
			container: this.element.querySelector('.section-how-we-work--svg'),
			loop: false,
			path: document.body.getAttribute('data-theme-url') + 'assets/lottie/venn-diagram-v2.json',
			renderer: 'svg',
			rendererSettings: {
				hideOnTransparent: false,
				preserveAspectRatio: 'xMinYMin slice',
				progressiveLoad: false
			}
		});

		this.animation.addEventListener('DOMLoaded', this.animationLoaded);


		window.addEventListener('resize', this.resize);
	}


	// Public Methods
	destroy() {
		this.disable();
		this.animation.destroy();
		delete this.animation;
		delete this.animationIsLoaded;
		delete this.asscroll;
		delete this.container;
		delete this.element;
		delete this.fixed;
	}
	enable() {
		this.enabled = true
		if (window.innerWidth < 768) {
			this.asscroll.off('update', this.scroll);
			this.asscroll.on('scroll', this.scrollMobile);
			return;
		}

		this.asscroll.on('update', this.scroll);
		this.asscroll.off('scroll', this.scrollMobile);
	}
	disable() {
		this.enabled = false
		this.asscroll.off('update', this.scroll);
		this.asscroll.off('scroll', this.scrollMobile);
	}

	resize() {
		if (this.enabled) {
			this.enable()
			return;
		}

		this.disable()
	}

	// Event Handlers
	animationLoaded() {
		this.animation.removeEventListener('DOMLoaded', this.animationLoaded);

		// HACK to force Lottie animation to draw its first frame off screen
		this.animation.playSegments([0, this.animation.totalFrames], true);
		const self = this;
		setTimeout(() => {
			self.animationIsLoaded = true;
		}, 1000);


	}
	scroll({ currentPos }) {

		let { top } = this.container.getBoundingClientRect();
		const elementHeight = this.container.offsetHeight;
		const windowHeight = window.innerHeight;
		let height = windowHeight - elementHeight;
		let percent = Math.min(1, Math.max(0, top / height));

		if (window.innerWidth < 768) {
			const offset = windowHeight * 0.3;
			top -= offset;
			height = elementHeight - offset;
			percent = Math.min(1, Math.max(0, -top / height));
		}

		if (this.animationIsLoaded) {
			const frame = Math.floor((this.animation.totalFrames - 1) * percent);
			this.animation.goToAndStop(frame, true);
		}

		const steps = 5;
		const step = Math.floor(steps * percent);
		for (let i=0, l=steps+1; i<l; i++) {
			if (i === step) {
				this.element.classList.add('on-item-' + i);
			} else {
				this.element.classList.remove('on-item-' + i);
			}
		}

		if (top <= height) {
			this.element.classList.add('is-bottom');
			this.element.classList.remove('is-sticky');
			this.fixed.style.transform = 'translate3d(0, 0, 0)';
		} else if (top <= 0) {
			this.element.classList.remove('is-bottom');
			this.element.classList.add('is-sticky');
			this.fixed.style.transform = `translate3d(0, ${currentPos}px, 0)`;
		} else {
			this.element.classList.remove('is-bottom');
			this.element.classList.remove('is-sticky');
			this.fixed.style.transform = 'translate3d(0, 0, 0)';
		}

	}

	scrollMobile(scrollPos) {

		let windowHeightPosition = window.innerHeight / 2;
		let totalItems = this.sectionItems.length;

		this.sectionItems.forEach((sectionItem, i) => {

			let sectionItemScrollTop = sectionItem.offsetTop - scrollPos

			if ((sectionItemScrollTop + (sectionItem.offsetHeight * 2)) < windowHeightPosition || (sectionItemScrollTop > windowHeightPosition)) {

				// Prevent removing the highlight for the last item once we're past it
				if ((sectionItemScrollTop < windowHeightPosition) && i == (totalItems - 1)) {
					return;
				}

				if (i <= (totalItems - 1)) {
					this.element.classList.remove('on-item-' + i);
				}
			} else if (sectionItemScrollTop < windowHeightPosition) {
				this.element.classList.add('on-item-' + i);
			}
		})
	}

}
